<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="error"
      :previous="true"
      title="Bestelling afronden"
      :nextColor="[rootStore.theme.actionColor, 'white']"
      @next-step="submitOrder"
      @prev-step="$router.push({ name: 'scanOrderInvoice' })"
    ></next-prev-menu>
    <div class="card">
      <div class="confirm-card">
        <div class="card-2col">
          <description
            :description="order.instruction"
            @goTo="$router.push({ name: 'scanOrderPickUp' })"
            @addError="addError"
            @removeError="removeError"
          ></description>

          <invoice
            :order="order"
            @goTo="$router.push({ name: 'scanOrderInvoice' })"
            @addError="addError"
            @removeError="removeError"
          ></invoice>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="confirm-card">
        <div class="card-2col">
          <pick-up
            :order="order"
            @goTo="$router.push({ name: 'scanOrderPickUp' })"
            @addError="addError"
            @removeError="removeError"
          ></pick-up>
          <deliver
            :order="order"
            orderType="deliver"
            @goTo="$router.push({ name: 'scanOrderDeliver' })"
            @addError="addError"
            @removeError="removeError"
          ></deliver>
        </div>

        <div class="card-2col">
          <medium
            :medium="order.medium"
            @goTo="$router.push({ name: 'scanOrderDeliver' })"
            @addError="addError"
            @removeError="removeError"
          ></medium>
          <div></div>
        </div>
      </div>
      <div class="confirm-footer">
        <legal class="legal"></legal>

        <next-button
          label="Bestelling afronden"
          :disabled="error"
          :background-color="rootStore.theme.actionColor"
          :text-color="'white'"
          @click="submitOrder"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Description from '@/components/confirm/Description.vue'
import Deliver from '@/components/confirm/Deliver.vue'
import Invoice from '@/components/confirm/Invoice.vue'
import Medium from '@/components/confirm/Medium.vue'
import Legal from '@/components/confirm/Legal.vue'
import { mapStores } from 'pinia'
import { useScanOrderStore } from '@/features/scanOrder/ScanOrder.store'
import { EventBus } from '@/eventbus/EventBus'

import NextPrevMenu from '@/components/NextPrevMenu.vue'
import PickUp from '@/components/confirm/PickUp'
import NextButton from '@/components/NextButton.vue'

export default {
  data() {
    return {
      totalPrints: 0,
      hideSpecs: false
    }
  },
  components: {
    Description,
    PickUp,
    Deliver,
    Invoice,
    Legal,
    Medium,
    NextPrevMenu,
    NextButton
  },
  methods: {
    addError(val) {
      this.scanOrderStore.addOrderError(val)
    },
    removeError(val) {
      this.scanOrderStore.removeOrderError(val)
    },
    submitOrder() {
      EventBus.emit('submitOrder')
    }
  },
  computed: {
    ...mapStores(useScanOrderStore),
    order() {
      return this.scanOrderStore.orderDetails
    },
    error() {
      return this.scanOrderStore.orderErrors.length > 0
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.card .card-2col {
  min-height: auto;
}

.card .card-default {
  min-height: auto;
}

.card-list {
  margin-bottom: 10px;
}

.instruction-holder {
  margin: 10px 0;
  white-space: pre-line;
}

.print-file-list {
  li {
    margin-left: 13px;
    margin-right: 13px;
    //border-bottom: 1px solid $list-divider;
    padding: 4px 0;
  }

  li:first-child {
    //padding-top: 0;
  }

  /* 		li:last-child{
			border: none;
		} */

  .file-table {
    display: table;
    table-layout: fixed;
    width: 100%;
    min-height: 56px;
  }

  .file-row {
    display: table-row;
  }
}

.filename-holder {
  display: table-cell;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  padding: 4px 0;
}

.specs-holder {
  text-align: right;
  display: table-cell;
  vertical-align: middle;
}

.template-name {
  padding-left: 7px;
}
</style>
